import React, { useContext } from "react";
import styled from "styled-components";
import { Link, useStaticQuery, graphql } from "gatsby";
import { useIntl } from "gatsby-plugin-intl";

import NotificationBanner from "./notificationBanner";
import IPhoneXModal from "../common/messageHub/iphoneXModal";
import BagButton from "./bagButton";
import MobileNavMenu from "./mobileNavMenu";
import { NavMenu, StyledLink } from "./navMenu";
import { KCLogo } from "../common/kcLogo";
import { GlobalStateContext } from "../context";

const StyledWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 10;
`;

const StyledTopWrapper = styled.div`
  position: relative;
  ${(props) =>
    props.isMobileNavShown ? "transparent" : props.theme.color.lightGrey};
`;

const LeftMenuWrapper = styled.div`
  flex-basis: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  display: block;
  padding: 0 0.2rem;
`;

const RightMenuWrapper = styled.div`
  flex: 1;
  flex-basis: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledTopbar = styled.div`
    position: relative;
    background-color: ${(props) => props.theme.color.transparent};
    display: flex;
    align-items: center;
    transition: opacity 1s;
    z-index: 200;
    height: 3rem;
    // border-bottom: 1px solid ${(props) => props.theme.color.white};
    ${(props) => props.theme.responsive.desktop} {
        height: 3.4rem;
        opacity: 0.8;
        &:hover {
            opacity: 1;
        }
    }
    & ${RightMenuWrapper}:hover {
        border-color: blue;
    }
`;

const LogoWrapper = styled.div``;

export default function Topbar({
  color = "black",
  location,
  isShopPage,
  ...props
}) {
  const state = useContext(GlobalStateContext);

  return (
    <StyledWrapper>
      {isShopPage && <NotificationBanner location={location} />}
      <StyledTopWrapper isMobileNavShown={state.isMobileNavShown}>
        <IPhoneXModal />
        <StyledTopbar>
          <MobileNavMenu color={color} />
          <NavMenu color={color} />
          <LeftMenuWrapper>
            <Link to="/">
              <KCLogo color={color} />
            </Link>
          </LeftMenuWrapper>
          <RightMenuWrapper>
            <BagButton color={color} />
          </RightMenuWrapper>
        </StyledTopbar>
      </StyledTopWrapper>
    </StyledWrapper>
  );
}
